import {websiteApiBase} from './websiteApiBase';
import { deviceTimezone } from './deviceTimezone';
export const BUSINESS_API = websiteApiBase(process.env.REACT_APP_APP_API_URL, typeof window === 'undefined' ? '' : window.location.hostname);
export const TOKEN_KEY = 'orrbbit_business_access';
export const DRAFT_KEY = 'orrbbit_business_setup';
export async function businessRequest(path, { method = 'GET', body, token = localStorage.getItem(TOKEN_KEY) } = {}) {
  if (path === '/auth/register' && body) body = {...body, timezone: deviceTimezone()};
  if (path === '/events' && method === 'POST' && body) body = {timezone: deviceTimezone(), ...body};
  const response = await fetch(`${BUSINESS_API}${path}`, {
    method,
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}), ...(body ? { 'Content-Type': 'application/json' } : {}) },
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const detail = typeof data.detail === 'string' ? data.detail : Array.isArray(data.detail) ? data.detail.map(item => `${(item.loc || []).filter(part => part !== 'body').join(' ')}: ${item.msg || 'Please check this field.'}`).join(' · ') : 'Please check your details and try again.';
    const error = new Error(detail);
    error.status = response.status;
    throw error;
  }
  return data;
}
